export default "<div class=\"name\">{{player.name}}</div>\n<div>\n  \n<hand [cards]=\"cards$ | async\" [vertical]=\"vertical\"></hand>\n</div>\n"